import config from '../config'
import http from '../http'

export default{
	//发送消息--内部会话
	sentMessage:async function(payload) {
		const res = await http({
			url: config.SENT_MESSAGE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//卖家获取消息--内部会话
	getUserMessage:async function(payload) {
		const res = await http({
			url: config.GET_USER_MESSAGE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//标记为已读--内部会话
	readMessage:async function(payload) {
		const res = await http({
			url: config.READ_MESSAGE,
			method: 'post',
			data: payload
		})
		return res.data
	},
	//发送图处--内部会话
	sendImg:async function(payload) {
		const res = await http({
			url: config.UPLOAD_IMG,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取当前用户某个店铺近期消息列表
	getBuyerMessageByshopId:async function(payload) {
		const res = await http({
			url: config.GET_SHOP_MESSAGE,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
}
